import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useUserApi } from "../../store/api/hooks/userApiHook";

/** Sign out from the locked screens. The logout saga clears the session, which sends the user back to /login. */
export function useConsentSignOut() {
  const { t } = useTranslation("consent");
  const userApi = useUserApi();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const signOut = () => {
    setIsSigningOut(true);
    userApi.logout(
      {},
      () => setIsSigningOut(false),
      () => {
        setIsSigningOut(false);
        toast.error(t("signOutFailed"));
      }
    );
  };

  return { signOut, isSigningOut };
}
